// src/data/tasks.js

export const initialTasks = [
  {
    id: "T-003",
    title: "Engine Overheating Diagnosis",

    technician: {
      name: "Kevin Kiptoo",
      phone: "0712456789",
      email: "kevin.kiptoo@agrifundi.com"
    },

    customer: {
      name: "Brian Mutua",
      phone: "0711122233",
      location: "Nakuru, Kenya"
    },

    tractor: {
      model: "Massey Ferguson 245",
      serial: "MF245_77",
      engineHours: 2300,
      year: 2018
    },

    description: "Engine overheating diagnosis.",
    assignedDate: "2025-02-07",
    dueDate: "2025-02-09",
    estimatedHours: 4,
    actualHours: null,
    status: "In Progress",

    checklist: [
      { text: "Inspect coolant level", completed: true },
      { text: "Check thermostat", completed: true },
      { text: "Test radiator fan", completed: false }
    ],

    location: {
      lat: -1.286389,
      lng: 36.817223,
      name: "Nairobi CBD"
    },

    comments: [
      {
        status: "In Progress",
        description: "Technician confirmed coolant levels were low.",
        images: ["https://via.placeholder.com/150"],
        time: "2025-02-07 09:15 AM"
      },
      {
        status: "Completed",
        description: "Issue resolved after thermostat replacement.",
        images: ["https://via.placeholder.com/160"],
        time: "2025-02-07 03:40 PM"
      }
    ],

    attachments: ["https://via.placeholder.com/200"]
  },

  {
    id: "T-002",
    title: "Hydraulic Pump Replacement",

    technician: {
      name: "Peter Otieno",
      phone: "0713456677",
      email: "peter.otieno@agrifundi.com"
    },

    customer: {
      name: "Richard Kibet",
      phone: "0719876543",
      location: "Eldoret, Kenya"
    },

    tractor: {
      model: "Kubota MU4501",
      serial: "MU4501_998",
      engineHours: 1800,
      year: 2020
    },

    description: "Hydraulic pump replacement.",
    assignedDate: "2025-02-01",
    dueDate: "2025-02-07",
    estimatedHours: 10,
    actualHours: null,
    status: "In Progress",

    checklist: [
      { text: "Remove pump", completed: true },
      { text: "Install new pump", completed: false },
      { text: "Test pressure", completed: false }
    ],

    location: {
      lat: -1.3,
      lng: 36.85,
      name: "Upperhill, Nairobi"
    },

    comments: [
      {
        status: "In Progress",
        description: "Old pump successfully removed.",
        images: [],
        time: "2025-02-02 11:00 AM"
      },
      {
        status: "Issue",
        description: "New pump had a damaged seal; awaiting replacement.",
        images: ["https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?auto=format&fit=crop&w=300&q=60"],
        time: "2025-02-03 02:20 PM"
      }
    ],

    attachments: []
  },

  {
    id: "T-001",
    title: "Routine Engine Service",

    technician: {
      name: "John Doe",
      phone: "0711002200",
      email: "john.doe@agrifundi.com"
    },

    customer: {
      name: "Farmer Jane",
      phone: "0715556667",
      location: "Kiambu, Kenya"
    },

    tractor: {
      model: "John Deere 5050D",
      serial: "JD12345",
      engineHours: 2900,
      year: 2017
    },

    description: "Routine engine service and safety checks.",
    assignedDate: "2025-02-05",
    dueDate: "2025-02-10",
    estimatedHours: 6,
    actualHours: null,
    status: "Pending",

    checklist: [
      { text: "Change oil", completed: true },
      { text: "Inspect belts", completed: false },
      { text: "General inspection", completed: false }
    ],

    location: {
      lat: -1.28,
      lng: 36.82,
      name: "Westlands, Nairobi"
    },

    comments: [
      {
        status: "Note",
        description: "Technician scheduled to begin work tomorrow morning.",
        images: [],
        time: "2025-02-05 05:30 PM"
      }
    ],

    attachments: []
  }
];

// Helper to generate new IDs
export const generateTaskId = (count) =>
  "T-" + String(count + 1).padStart(3, "0");
